import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import {
  dateToTimestamp,
  removeReadOnlyFields,
  timestampToDate,
} from 'src/utils/fieldNormalizers';

import { Note } from './_types';

const readOnlyFields = ['created_at', 'updated_at'];

export function normalizeNote(note): Note {
  const camelized = camelcaseKeys(note, { deep: true });

  return {
    ...camelized,
    date: timestampToDate(camelized.date),
    createdAt: timestampToDate(camelized.createdAt),
    updatedAt: timestampToDate(camelized.updatedAt),
  };
}

export function denormalizeNote(note: Partial<Note>) {
  const decamelized = decamelizeKeys(note, { deep: true });

  removeReadOnlyFields(decamelized, readOnlyFields);

  return {
    ...decamelized,
    date: dateToTimestamp(decamelized.date),
  };
}
